export const formatDate = (value, fallback = "-") => {
  if (!value) return fallback
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return fallback
  return date
    .toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Asia/Kolkata" })
    .split("/")
    .join("-")
}

export const formatMobile = (mobile, fallback = "-") => {
  if (mobile === null || mobile === undefined || mobile === "") return fallback
  const digits = String(mobile).replace(/\D/g, "")
  const local = digits.length === 12 && digits.startsWith("91") ? digits.slice(2) : digits
  if (local.length !== 10) return String(mobile)
  return `+91 ${local.slice(0, 5)} ${local.slice(5)}`
}

export const formatINR = (amount, fallback = "-") => {
  if (amount === null || amount === undefined || amount === "") return fallback
  const value = Number(amount)
  if (Number.isNaN(value)) return fallback
  return `₹${value.toLocaleString("en-IN")}`
}
